var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styled } from 'goober';
import React, { forwardRef, useRef } from 'react';
import { Loading } from '../styled/Basic';
var SIZE_DEFAULTS = Object.freeze({
    small: {
        height: '24px',
        minWidth: '24px',
        fontSize: '11px',
        padding: '6px 10px',
        lineHeight: '15px',
    },
    large: {
        height: '32px',
        minWidth: '32px',
        fontSize: '12px',
        padding: '9px 16px',
        lineHeight: '14px',
    },
    icon: {
        small: { height: '24px', width: '24px' },
        large: { height: '32px', width: '32px' },
    },
});
var ButtonIconContainer = styled('span')(function (_a) {
    var $content = _a.$content;
    return {
        display: 'inline-flex',
    };
});
var ButtonPrimitive = styled('button', forwardRef)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    box-sizing: border-box;\n    user-select: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    text-align: center;\n    white-space: nowrap;\n    border-radius: 4px;\n    border-style: solid;\n    appearance: none;\n    outline: none;\n    cursor: pointer;\n    transition: 0.1s;\n    border-width: 2px;\n    font-family: inherit;\n    overflow: hidden;\n\n    &:focus {\n        outline-style: solid;\n        outline-color: ", ";\n        outline-width: 1px;\n    }\n\n    &:disabled,\n    &:disabled > .fs-button_spinner {\n        cursor: not-allowed;\n    }\n\n    ", ", ", " > svg,\n    ", " > .fs-icon_svg > .fs-icon_path,\n    ", " > .fs-icon_svg > .fs-icon_rect {\n        color: inherit;\n        fill: inherit;\n        background-color: inherit;\n    }\n"], ["\n    position: relative;\n    box-sizing: border-box;\n    user-select: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    text-align: center;\n    white-space: nowrap;\n    border-radius: 4px;\n    border-style: solid;\n    appearance: none;\n    outline: none;\n    cursor: pointer;\n    transition: 0.1s;\n    border-width: 2px;\n    font-family: inherit;\n    overflow: hidden;\n\n    &:focus {\n        outline-style: solid;\n        outline-color: ", ";\n        outline-width: 1px;\n    }\n\n    &:disabled,\n    &:disabled > .fs-button_spinner {\n        cursor: not-allowed;\n    }\n\n    ", ", ", " > svg,\n    ", " > .fs-icon_svg > .fs-icon_path,\n    ", " > .fs-icon_svg > .fs-icon_rect {\n        color: inherit;\n        fill: inherit;\n        background-color: inherit;\n    }\n"])), function (props) { return props.theme.colors.ui.dark; }, ButtonIconContainer, ButtonIconContainer, ButtonIconContainer, ButtonIconContainer);
function getButtonTypeDefaults(themeColorKey, themeColors, content) {
    var color = themeColors[themeColorKey];
    return {
        primary: {
            border: 'none',
            color: themeColors.ui.white,
            fill: themeColors.ui.white,
            backgroundColor: color.w500,
            '&:hover': {
                backgroundColor: color.w700,
            },
            '&:active': {
                backgroundColor: color.w900,
            },
            '&:disabled, &:disabled > .fs-button_spinner': {
                backgroundColor: themeColors.neutral.w200,
                color: themeColors.neutral.w700,
                fill: themeColors.neutral.w700,
            },
        },
        secondary: {
            borderStyle: 'solid',
            color: color.w500,
            fill: color.w500,
            borderColor: content === 'icon' ? 'transparent' : color.w500,
            backgroundColor: themeColors.ui.white,
            '&:hover': {
                borderColor: color.w500,
                color: themeColors.ui.white,
                fill: themeColors.ui.white,
                backgroundColor: color.w500,
            },
            '&:active': {
                borderColor: color.w700,
                backgroundColor: color.w700,
            },
            '&:disabled, &:disabled > .fs-button_spinner': {
                borderColor: themeColors.neutral.w700,
                fill: themeColors.neutral.w700,
                color: themeColors.neutral.w700,
                backgroundColor: content === 'icon' ? 'transparent' : themeColors.ui.white,
            },
        },
        tertiary: {
            border: 'none',
            color: themeColorKey === 'neutral' ? themeColors.ui.dark : color.w500,
            fill: themeColorKey === 'neutral' ? themeColors.ui.dark : color.w500,
            backgroundColor: 'transparent',
            '&:hover': {
                color: themeColorKey === 'neutral' ? themeColors.ui.dark : color.w700,
                fill: themeColorKey === 'neutral' ? themeColors.ui.dark : color.w700,
                backgroundColor: color.w50,
            },
            '&:active': {
                color: themeColorKey === 'neutral' ? themeColors.ui.dark : color.w900,
                fill: themeColorKey === 'neutral' ? themeColors.ui.dark : color.w900,
                backgroundColor: color.w300,
            },
            '&:disabled, &:disabled > .fs-button_spinner': {
                color: themeColors.neutral.w700,
                fill: themeColors.neutral.w700,
                backgroundColor: 'transparent',
            },
        },
    };
}
var Button = styled(ButtonPrimitive, forwardRef)(function (_a) {
    var theme = _a.theme, _b = _a.$color, $color = _b === void 0 ? 'primary' : _b, _c = _a.$type, $type = _c === void 0 ? 'primary' : _c, _d = _a.$size, $size = _d === void 0 ? 'large' : _d, $content = _a.$content;
    var buttonTypeDefaults = getButtonTypeDefaults($color, theme.colors, $content);
    var sizeDefault = $content === 'icon' ? SIZE_DEFAULTS.icon[$size] : SIZE_DEFAULTS[$size];
    return __assign(__assign(__assign({}, sizeDefault), buttonTypeDefaults[$type]), { '& > span > svg:not(.fs-icon_svg)': {
            marginRight: $size === 'small' ? '8px' : '16px',
        }, 'span > .fs-icon_svg': {
            marginRight: $content === 'icon'
                ? $size === 'small'
                    ? '-4px'
                    : '-8px'
                : $content === 'icon-title'
                    ? $size === 'small'
                        ? '4px'
                        : '8px'
                    : undefined,
            marginLeft: $content === 'icon' || $content === 'icon-title' ? ($size === 'small' ? '-4px' : '-8px') : undefined,
        } });
});
function FSButton(props, ref) {
    var _a;
    var btnRef = useRef();
    var _b = props.loading, loading = _b === void 0 ? false : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, title = props.title, _d = props.style, style = _d === void 0 ? {} : _d, icon = props.icon, _e = props.$color, $color = _e === void 0 ? 'primary' : _e, rest = __rest(props, ["loading", "disabled", "title", "style", "icon", "$color"]);
    function initRefs(instance) {
        btnRef.current = instance;
        if (typeof ref === 'function') {
            ref(instance);
        }
        if (typeof ref === 'object' && ref !== null) {
            ref.current = instance;
        }
    }
    var Icon = icon;
    var contentType = !!Icon && !title ? 'icon' : !!title && !!Icon ? 'icon-title' : 'title';
    return (React.createElement(Button, __assign({}, rest, { ref: initRefs, "$color": $color, "$content": contentType, disabled: disabled || loading, style: loading ? __assign(__assign({}, style), { width: (_a = btnRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth }) : style }),
        Icon ? (React.createElement(React.Fragment, null,
            React.createElement(ButtonIconContainer, { "$content": contentType }, typeof Icon === 'function' ? (React.createElement(Icon, { cursor: "inherit", height: rest.$size === 'small' ? 24 : 32, width: rest.$size === 'small' ? 24 : 32 })) : (Icon)),
            title)) : (title),
        loading && (React.createElement("span", { className: "fs-button_spinner", style: {
                display: 'grid',
                placeItems: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
            } },
            React.createElement(Loading, null)))));
}
export default forwardRef(FSButton);
var templateObject_1;
